module.exports = "../study/imgs/maps/Nagano/S8/Ecosystem/Fagus/Nagano_Fagus_HadGEM2_RCP85_End.png";